import { render, staticRenderFns } from "./bld.vue?vue&type=template&id=24021c4a&scoped=true&"
import script from "./bld.vue?vue&type=script&lang=js&"
export * from "./bld.vue?vue&type=script&lang=js&"
import style0 from "./bld.vue?vue&type=style&index=0&id=24021c4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24021c4a",
  null
  
)

export default component.exports